export default {
  name: 'BaseQueryDatePicker',

  computed: {
    query () {
      let parent = this.$parent || this.$root
      let name = parent.$options.name
      while (name !== 'BaseQuery') {
        parent = parent.$parent
        if (!parent) break
        name = parent.$options.name
      }
      return parent
    }
  },

  mounted () {
    this.query && this.query.$emit('addField', this)
  },

  beforeDestroy () {
    this.query && this.query.$emit('removeField', this)
  },

  methods: {
    resetField () {
      this.$emit('input', '')
    }
  },

  render (h) {
    const props = {
      attrs: this.$attrs,
      on: this.$listeners
    }
    return <el-date-picker { ...props } />
  }
}
